/**
 * Extrait tous les modules disponibles depuis dashboardItems
 * Retourne un objet avec les titres comme clés et les hrefs comme valeurs
 */
export const getAvailableModules = () => {
  const staticModules = {
    'dashboard': '/',
    'gestion': '/pages',
    'opportunité': '/gestion/opportunity',
    'opportunite': '/gestion/opportunity',
    'devis': '/gestion/devis',
    'commande': '/gestion/commande',
    'bon de livraison': '/gestion/bon',
    'bon simple': '/gestion/bon',
    'bon multiple': '/gestion/bon/multiple',
    'facture': '/gestion/facture',
    'facture auto': '/gestion/facture/auto',
    'achat': '/gestion/achat',
    'pré-réception': '/gestion/container',
    'pre-reception': '/gestion/container',
    'reception': '/gestion/reception',
    'véhicule et machine': '/gestion/voiture-machine',
    'vehicule et machine': '/gestion/voiture-machine',
    'fichier de base': '/file',
    'clients': '/file/client',
    'matières': '/file/matiere',
    'matieres': '/file/matiere',
    'articles': '/file/article',
    'fournisseurs': '/file/fournisseur',
    'stocks': '/file/stock',
    'débits': '/file/debit',
    'debits': '/file/debit',
    'carrousel': '/file/carrousel',
    'crm': '/rh/suivi-client',
    'suivi client': '/rh/suivi-client',
    'processus qualité': '/rh/non-conformite',
    'gestion documentaire': '/gestion/documentation',
    'gestion non conformités': '/rh/non-conformite',
    'plan d\'action': '/rh/plan-action',
    'opportunités et risques': '/rh/opportunites-risques',
    'revue de direction': '/rh/revue-direction',
    'ressource humaine': '/rh/organigramme',
    'organigramme': '/rh/organigramme',
    'suivi personnel': '/rh/fiche-personnel',
    'entretien professionnel': '/rh/entretien-professionnel',
    'formations': '/rh/formation',
    'recrutements': '/rh/recrutement',
    'fiche de poste': '/rh/fiche-poste',
    'habilitation': '/rh/habilitation',
    'compétence': '/rh/competences',
    'competence': '/rh/competences',
    'messagerie': '/gestion/messagerie',
    'paramètres': '/settings/setting',
    'parametres': '/settings/setting',
    'utilisateurs': '/settings/users',
    'permissions': '/settings/permission',
    'modes de règlement': '/settings/modereglement',
    'terme de livraison': '/settings/livraisonTerm',
    'terme de paiement': '/settings/paiementTerm',
    'type de facturation': '/settings/typefacturation',
    'taux de tva': '/settings/tax',
    'échéances': '/settings/echeance',
    'echeances': '/settings/echeance',
    'devises': '/settings/devise',
    'opérations': '/settings/operation',
    'operations': '/settings/operation',
    'gammes': '/settings/gamme',
    'unité conditionnement': '/settings/conditionnement/unit',
    'type conditionnement': '/settings/conditionnement/type',
    'famille de matière': '/settings/family/matiere',
    'famille d\'article': '/settings/family/article',
    'activité': '/settings/activity',
    'activite': '/settings/activity',
    'imprimante': '/settings/printer',
    'machines': '/settings/machine',
    'export quadratus': '/gestion/quadratus',
    'previsionnel': '/gestion/previsionnel',
    'exports': '/export',
    'développeur': '/gestion/changelog',
    'developpeur': '/gestion/changelog',
  };

  return staticModules;
};

/**
 * Parse le contenu pour trouver les mentions @module et les rendre cliquables
 */
export const parseModuleMentions = (content, onModuleClick) => {
  if (!content) return [];
  
  const modules = getAvailableModules();
  const parts = [];
  // Regex pour capturer @ suivi d'un mot (lettres et chiffres uniquement) jusqu'à un espace, ponctuation ou fin
  const regex = /@([a-zA-ZÀ-ÿ0-9]+)/g;
  let lastIndex = 0;
  let match;

  while ((match = regex.exec(content)) !== null) {
    // Vérifier que le caractère suivant n'est pas alphanumérique (pour éviter de capturer trop)
    const charAfter = content[match.index + match[0].length];
    if (charAfter && /[a-zA-ZÀ-ÿ0-9]/.test(charAfter)) {
      // Si le caractère suivant est alphanumérique, continuer (ce n'est pas une mention complète)
      continue;
    }

    // Ajouter le texte avant la mention
    if (match.index > lastIndex) {
      parts.push({
        type: 'text',
        content: content.substring(lastIndex, match.index)
      });
    }

    // Trouver le module correspondant
    const mentionText = match[1].toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
    
    let moduleHref = null;
    let matchedKey = null;
    
    // Chercher une correspondance exacte d'abord
    for (const [key, href] of Object.entries(modules)) {
      const normalizedKey = key.toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
      if (normalizedKey === mentionText) {
        moduleHref = href;
        matchedKey = key;
        break;
      }
    }
    
    // Si pas de correspondance exacte, chercher une correspondance partielle
    if (!moduleHref) {
      for (const [key, href] of Object.entries(modules)) {
        const normalizedKey = key.toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '');
        // Vérifier si le texte mentionné est contenu dans la clé ou vice versa
        if (normalizedKey.includes(mentionText) || mentionText.includes(normalizedKey)) {
          moduleHref = href;
          matchedKey = key;
          break;
        }
      }
    }

    // Ajouter la mention
    parts.push({
      type: 'mention',
      content: `@${match[1]}`,
      href: moduleHref,
      onClick: moduleHref ? () => onModuleClick(moduleHref) : null,
      matchedKey: matchedKey
    });

    lastIndex = regex.lastIndex;
  }

  // Ajouter le texte restant
  if (lastIndex < content.length) {
    parts.push({
      type: 'text',
      content: content.substring(lastIndex)
    });
  }

  // Si aucune mention trouvée, retourner le texte complet
  if (parts.length === 0) {
    return [{
      type: 'text',
      content: content
    }];
  }

  return parts;
};

